import HolacracyMarkBlue from 'assets/icons/holacracyMarkBlue.svg'

export default HolacracyMarkBlue
